import {
  ICreateScript,
  IPreportstat,
  IProject,
  IProjectScene,
  IProjectUser,
  IPvisitStatistics,
  IPvisitStatTrend,
  IScenePage,
  ICreateTopScript,
} from "@/interfaces";
import { ProjectState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { State } from "../state";
import { readMyProjects, readProjectScenes } from "./getters";
import { store } from "..";
import {
  dispatchGetMyProjects,
  dispatchGetProjectScenes,
  dispatchGetProjectUsers,
} from "./actions";

export const mutations = {
  setProjects(state: ProjectState, payload: IProject[]) {
    state.projectList = payload;
  },
  setProjectDetail(state: ProjectState, payload: IProject) {
    state.project = payload;
  },
  setGamesDate(state: ProjectState, payload: any) {
    state.GamesDate = payload;
  },
  setHokIcon(state: ProjectState, payload: any) {
    state.hokIcon = payload;
  },
  setHokSkinVersions(state: ProjectState, payload: any) {
    state.hok_skin_versions = payload;
  },
  setHokSkinDevices(state: ProjectState, payload: any) {
    state.hok_skin_devices= payload;
  },
  setHokSkinData(state: ProjectState, payload: any) {
    state.hok_skin_data= payload;
  },
  setHokSkinDataPage(state: ProjectState, payload: any) {
    state.hok_skin_data_page= payload;
  },
  setHokIn(state: ProjectState, payload: any) {
    state.hokIn = payload;
  },
  setHokInV1(state: ProjectState, payload: any) {
    state.HokInV1 = payload;
  },
  setHokInAdd(state: ProjectState, payload: any) {
    state.hokIn_add = payload;
  },
  setHokInAddV1(state: ProjectState, payload: any) {
    state.hokIn_add_v1 = payload;
  },
  setHokOutAdd(state: ProjectState, payload: any) {
    state.hokOut_add = payload;
  },
  setHokOutAddV1(state: ProjectState, payload: any) {
    state.hokOut_add_v1 = payload;
  },
  setHokOut(state: ProjectState, payload: any) {
    state.hokOut = payload;
  },
  setHokOutV1(state: ProjectState, payload: any) {
    state.hokOutV1 = payload;
  },
  setHokDeviceList(state: ProjectState, payload: any) {
    state.hokDeviceList= payload;
  },
  setHokDeviceOutList(state: ProjectState, payload: any) {
    state.hokDeviceOutList= payload;
  },
  setModelList(state: ProjectState, payload: any) {
    state.modelList= payload;
  },
  setModelOptions(state: ProjectState, payload: any) {
    state.modelOptions= payload;
  },
  setHokInSkinTrend(state: ProjectState, payload: any) {
    state.hokInSkinTrend = payload;
  },
  setHokOutSkinTrend(state: ProjectState, payload: any) {
    state.hokOutSkinTrend = payload;
  },
  setGamesData(state: ProjectState, payload: any) {
    state.GamesData = payload;
  },
  setProjectScenes(state: ProjectState, payload: IProjectScene[]) {
    state.projectSceneList = payload;
  },
  setTopProjectScenes(state: ProjectState, payload: any) {
    state.top_project_scenes = payload;
  },
  setProjectScenesPage(state: ProjectState, payload: IScenePage) {
    state.projectScenePage = payload;
  },
  setProjectSgameSkinList(state: ProjectState, payload: any) {
    state.projectSgameSkinList = payload;
  },
  setProjectUsers(state: ProjectState, payload: IProjectUser[]) {
    state.projectUserList = payload;
  },
  setProjectScene(state: ProjectState, project: number) {
    dispatchGetProjectScenes(store, { project: project });
    readProjectScenes(store);
  },
  setCreateProjectScenes(state: ProjectState, payload: ICreateScript) {
    state.createScript = payload;
  },
  setCreateTopProjectScenes(state: ProjectState, payload: ICreateTopScript) {
    state.createTopScript = payload;
  },
  setProject(state: ProjectState, payload: IProject) {
    const projects = state.projectList.filter(
      (project: IProject) => project.id !== payload.id
    );
    projects.push(payload);
    state.projectList = projects;
    dispatchGetMyProjects(store);
    readMyProjects(store);
  },
  deleteProject(state: ProjectState, payload: number) {
    state.projectList = state.projectList.filter(
      (project: IProject) => project.id !== payload
    );
    state.myProjects = state.myProjects.filter(
      (project: IProject) => project.project.id !== payload
    );
    // dispatchGetMyProjects(store)
    // readMyProjects(store)
  },
  setMyProjects(state: ProjectState, payload: IProject[]) {
    state.myProjects = payload;
  },
  setProjectUser(state: ProjectState, project: number) {
    dispatchGetProjectUsers(store, project);
    // readProjectUsers(store)
  },
  setReportStat(state: ProjectState, payload: IPreportstat) {
    state.reportStat = payload;
  },
  setVisitStatistics(state: ProjectState, payload: IPvisitStatistics) {
    state.visitStatistics = payload;
  },
  setVisitStatTrend(state: ProjectState, payload: IPvisitStatTrend) {
    state.visitStatTrend = payload;
  },
  setMonitorTrend(state: ProjectState, payload: any) {
    state.monitorTrend = payload;
  },
  setMonitorUploadTrend(state: ProjectState, payload: any) {
    state.monitorUploadTrend = payload;
  },
  setMonitorList(state: ProjectState, payload: any) {
    state.monitorlist = payload;
  },
  setMonitorUploadList(state: ProjectState, payload: any) {
    state.monitorUploadList = payload;
  },
  setTopPerformance(state: ProjectState, payload: any) {
    state.topPerformance = payload;
  },
  setTopPerformanceList(state: ProjectState, payload: any) {
    state.topPerformanceList = payload;
  },
  setTopPerformanceListAdvance(state: ProjectState, payload: any) {
    state.topPerformanceListtAdvance = payload;
  },
  setTopPerformanceOld(state: ProjectState, payload: any) {
    state.topPerformanceOld = payload;
  },
  setTopProjectPerformance(state: ProjectState, payload: any) {
    state.topProjectPerformance = payload;
  },
  setSetTopOptions(state: ProjectState, payload: any) {
    state.topOptions = payload;
  },
  setTopLabelPerformance(state: ProjectState, payload: any) {
    state.topLabelPerformance = payload;
  },
  setTopMainLabelPerformance(state: ProjectState, payload: any) {
    state.topMainLabelPerformance = payload;
  },
  setTopModelPerformance(state: ProjectState, payload: any) {
    state.topModelPerformance = payload;
  },
  setTopLevelPerformance(state: ProjectState, payload: any) {
    state.topLevelPerformance = payload;
  },
  setTopTesterPerformance(state: ProjectState, payload: any) {
    state.topTesterPerformance = payload;
  },
  setTopCpuList(state: ProjectState, payload: any) {
    state.topCpuList = payload;
  },
  setTopProjectList(state: ProjectState, payload: any) {
    state.topProjectLis = payload;
  },
  setTopProblemSummary(state: ProjectState, payload: any) {
    state.topProblemSummary= payload;
  },
  setTopProblemByCpu(state: ProjectState, payload: any) {
    state.topProblemByCpu = payload;
  },
  setTopSceneList(state: ProjectState, payload: any) {
    state.topSceneList= payload;
  },
  setTopSceneListVersion(state: ProjectState, payload: any) {
    state.topSceneListVersion= payload;
  },
  setTopModelList(state: ProjectState, payload: any) {
    state.topModelList= payload;
  },
  setTopModelListVersion(state: ProjectState, payload: any) {
    state.topModelListVersion= payload;
  },
  setTopVersionList(state: ProjectState, payload: any) {
    state.topVersionList= payload;
  },
  setTopProjectType(state: ProjectState, payload: any) {
    state.topProjectType= payload;
  },
  setTopVersionData(state: ProjectState, payload: any) {
    state.topVersionData= payload;
  },
  setTopVersionListVersion(state: ProjectState, payload: any) {
    state.topVersionListVersion= payload;
  },
  setTopVersionListProblem(state: ProjectState, payload: any) {
    state.topVersionListProblem= payload;
  },
  setTestAppointment(state: ProjectState, payload: any) {
    state.testAppointment = payload;
  },
  setTestAppointmentAdamins(state: ProjectState, payload: any) {
    state.testAppointmentAdamins = payload;
  },
  setTestAppointmentTable(state: ProjectState, payload: any) {
    state.testAppointmentTable = payload;
  },
  setTestAppointmentTableAll(state: ProjectState, payload: any) {
    state.testAppointmentTableAll = payload;
  },
};

const { commit } = getStoreAccessors<ProjectState, State>("");

export const commitSetProjects = commit(mutations.setProjects);
export const commitSetProjectDetail = commit(mutations.setProjectDetail);
export const commitSetGamesDate = commit(mutations.setGamesDate);
export const commitSetHokIcon = commit(mutations.setHokIcon);
export const commitSetHokSkinVersions = commit(mutations.setHokSkinVersions);
export const commitSetHokSkinDevices = commit(mutations.setHokSkinDevices );
export const commitSetHokSkinData = commit(mutations.setHokSkinData  );
export const commitSetHokSkinDataPage = commit(mutations.setHokSkinDataPage   );
export const commitSetHokIn = commit(mutations.setHokIn);
export const commitSetHokInV1 = commit(mutations.setHokInV1);
export const commitSetHokInAdd = commit(mutations.setHokInAdd);
export const commitSetHokInAddV1 = commit(mutations.setHokInAddV1);
export const commitSetHokOutAdd = commit(mutations.setHokOutAdd);
export const commitSetHokOutAddV1 = commit(mutations.setHokOutAddV1);
export const commitSetHokOut = commit(mutations.setHokOut);
export const commitSetHokOutV1 = commit(mutations.setHokOutV1);
export const commitSetHokDeviceList = commit(mutations.setHokDeviceList);
export const commitSetHokDeviceOutList = commit(mutations.setHokDeviceOutList);
export const commitSetModelList = commit(mutations.setModelList );
export const commitSetModelOptions = commit(mutations.setModelOptions );
export const commitSetHokInSkinTrend = commit(mutations.setHokInSkinTrend );
export const commitSetHokOutSkinTrend = commit(mutations.setHokOutSkinTrend );
export const commitSetGamesData = commit(mutations.setGamesData);
export const commitSetProject = commit(mutations.setProject);
export const commitSetProjectScene = commit(mutations.setProjectScene);
export const commitSetCreateProjectScenes = commit(
  mutations.setCreateProjectScenes
);
export const commitSetCreateTopProjectScenes = commit(
  mutations.setCreateTopProjectScenes
);
export const commitDeleteProject = commit(mutations.deleteProject);
export const commitSetMyProjects = commit(mutations.setMyProjects);
export const commitSetProjectScenes = commit(mutations.setProjectScenes);
export const commitSetTopProjectScenes = commit(mutations.setTopProjectScenes );
export const commitSetProjectScenesPage = commit(
  mutations.setProjectScenesPage
);
export const commitSetProjectSgameSkinList = commit(
  mutations.setProjectSgameSkinList
);
export const commitSetProjectUsers = commit(mutations.setProjectUsers);
export const commitSetProjectUser = commit(mutations.setProjectUser);
export const commitSetReportStat = commit(mutations.setReportStat);
export const commitSetVisitStatistics = commit(mutations.setVisitStatistics);
export const commitSetVisitStatTrend = commit(mutations.setVisitStatTrend);
export const commitSetMonitorTrend = commit(mutations.setMonitorTrend);
export const commitSetMonitorUploadTrend = commit(
  mutations.setMonitorUploadTrend
);
export const commitSetMonitorList = commit(mutations.setMonitorList);
export const commitSetMonitorUploadList = commit(
  mutations.setMonitorUploadList
);
export const commitSetTopPerformance = commit(
  mutations.setTopPerformance
);
export const commitSetTopPerformanceList = commit(
  mutations.setTopPerformanceList
);
export const commitSetTopPerformanceListAdvance = commit(
  mutations.setTopPerformanceListAdvance
);
export const commitSetTopPerformanceOld = commit(
  mutations.setTopPerformanceOld
);
export const commitSetTopProjectPerformance = commit(
  mutations.setTopProjectPerformance
);
export const commitSetTopOptions = commit(
  mutations.setSetTopOptions
);
export const commitSetTopLabelPerformance = commit(
  mutations.setTopLabelPerformance
);
export const commitSetTopMainLabelPerformance = commit(
  mutations.setTopMainLabelPerformance
);
export const commitSetTopModelPerformance = commit(
  mutations.setTopModelPerformance
);
export const commitSetTopLevelPerformance = commit(
  mutations.setTopLevelPerformance
);
export const commitSetTopTesterPerformance = commit(
  mutations.setTopTesterPerformance
);
export const commitSetTopCpuList = commit(
  mutations.setTopCpuList 
);
export const commitSetTopProjectList = commit(
  mutations.setTopProjectList
);
export const commitSetTopProblemSummary = commit(
  mutations.setTopProblemSummary
);
export const commitSetTopProblemByCpu = commit(
  mutations.setTopProblemByCpu
);
export const commitSetTopSceneList = commit(
  mutations.setTopSceneList 
);
export const commitSetTopSceneListVersion = commit(
  mutations.setTopSceneListVersion 
);
export const commitSetTopModelList = commit(
  mutations.setTopModelList 
);
export const commitSetTopModelListVersion = commit(
  mutations.setTopModelListVersion
);
export const commitSetTopVersionList = commit(
  mutations.setTopVersionList
);
export const commitSetTopProjectType = commit(
  mutations.setTopProjectType
);
export const commitSetTopVersionData = commit(
  mutations.setTopVersionData 
);
export const commitSetTopVersionListVersion = commit(
  mutations.setTopVersionListVersion 
);
export const commitSetTopVersionListProblem = commit(
  mutations.setTopVersionListProblem  
);
export const commitSetTestAppointment = commit(
  mutations.setTestAppointment
);
export const commitSetTestAppointmentAdamins = commit(
  mutations.setTestAppointmentAdamins
);
export const commitSetTestAppointmentTable = commit(
  mutations.setTestAppointmentTable
);
export const commitSetTestAppointmentTableAll = commit(
  mutations.setTestAppointmentTableAll
);
